import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { QuoteDetail } from '@quorum/models/xs-resource';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'sha-quote-line-list',
  templateUrl: './quote-line-list.component.html',
  animations: [
    trigger('enterAnimation', [
      transition(':enter', [style({ opacity: 0 }), animate('500ms', style({ opacity: 1 }))]),
      transition(':leave', [style({ opacity: 1 }), animate('500ms', style({ opacity: 0 }))])
    ])
  ],
  styleUrls: ['./quote-line-list.component.scss']
})
export class QuoteLineListComponent implements OnInit {
  @Input() lines$: Observable<QuoteDetail>;
  @Output() selectLine: EventEmitter<QuoteDetail> = new EventEmitter();
  constructor() {}

  ngOnInit() {}

  displayEditCase(caseToEdit: QuoteDetail) {
    this.selectLine.emit(caseToEdit);
  }
}
